import { getRequest, postRequest } from '../httpclient/httpClient';

const GET_LEFT_MENU_SAVED_ORDER = 'saved_order/left_menu';
const SAVE_COLUMNS = 'saved_order/save';

export async function getLeftMenuOrder() {
  return await getRequest(GET_LEFT_MENU_SAVED_ORDER);
}

export async function saveLeftMenuColumnOrder(orderedColumn) {
  const body = {
    module: 'ui.template.leftmenu',
    value: orderedColumn
  };

  return (await postRequest(SAVE_COLUMNS, body)).data;
}
